<!-- Toolbar with Filter -->
<div class="fw-filter-box animated fadeIn jobs-header">
  <!-- Filter By Gear Name -->
  <div class="jobs-filter">
    <mat-form-field appearance="outline">
      <input
        test-id="protenance-tab-filter"
        [formControl]="gearNameFilter"
        matInput
        placeholder="{{ 'jobProvenance.labels.filterPlaceholder' | translate }}">
    </mat-form-field>
  </div>
  <!-- Statuses -->
  <div class="job-statuses">
    <ng-container *ngIf="summary$ | async as summary">
      <span *ngIf="summary.running > 0 || summary.pending > 0">
        <fw-icon size="small" color="primary">setting-gear</fw-icon>
        {{ 'common.labels.processing' | translate }}
      </span>
      <span>
        <fw-icon *ngIf="summary.complete > 0" size="small" color="green">done-check-tracked</fw-icon>
        {{ 'jobProvenance.labels.jobsProcessed' | translate | interpolate:summary.complete }}
      </span>
      <span *ngIf="summary.failed > 0">
        <fw-icon size="small" color="red">warning</fw-icon>
        {{ 'common.labels.errors' | translate | interpolate:summary.failed }}
      </span>
    </ng-container>
  </div>
  <button mat-flat-button color="primary" test-id="sessions-prov-refresh" (click)="refreshJobs()">
    {{ 'common.actions.refresh' | translate }}
  </button>
</div>

<!-- Card -->
<ng-container *ngIf="jobs$ | async as jobs; else loadingState">
  <ng-container *ngIf="jobs.length > 0; else emptyState">
    <div class="card">
      <table class="legacy-table legacy-table-tight">
        <thead class="fw-thead">
          <tr>
            <th>{{ 'common.labels.gear' | translate }}</th>
            <th *ngIf="jobPrioritization">{{ 'common.labels.priority' | translate }}</th>
            <th>{{ 'common.labels.input' | translate }}</th>
            <th>{{ 'common.labels.output' | translate }}</th>
            <th class="actions">{{ 'common.labels.actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr class="fw-tr" *ngFor="let job of jobs">
            <td test-id="sessions-prov-card" class="gear-info">
              <div class="gear-info-wrapper">
                <div [ngSwitch]="job.state" class="job-state">
                  <span *ngSwitchCase="'complete'"><fw-icon color="green" title="Complete">done-check-tracked</fw-icon></span>
                  <span *ngSwitchCase="'failed'"><fw-icon color="red" title="Failed">warning</fw-icon></span>
                  <span *ngSwitchCase="'cancelled'"><fw-icon color="red"title="Cancelled">minus</fw-icon></span>
                  <span *ngSwitchCase="'running'"><fw-icon color="orange" title="Running">setting-gear</fw-icon></span>
                  <span *ngSwitchCase="'pending'"><fw-icon color="slate" title="Pending">setting-gear</fw-icon></span>
                </div>
                <div class="gear-info-details overflow-ellipsis">
                  <strong>{{ job.name }}</strong><br>
                  <small class="text-muted">
                    {{ 'common.labels.user' | translate }}: {{ job.origin.type === 'system' ? 'System' : job.origin.id }}
                  </small><br>
                  <small class="text-muted">
                    {{ 'common.labels.updated' | translate }}: {{ job.modified | date:'M/dd/yyyy H:mm' }}
                  </small><br>
                </div>
              </div>
            </td>
            <td *ngIf="jobPrioritization" test-id="prov-job-priority">
              <span>
                {{ job.priority ? ('jobs.priority.' + job.priority | translate) : '' }}
              </span>
            </td>
            <td test-id="prov-input-files">
              <ng-container *ngFor="let input of job.inputList | slice:0:job.inputLimit">
                <span class="file-name">
                  <fw-ellipsis [text]="input.name" [tooltip]="input.tooltip"></fw-ellipsis>
                  <file-version-badge *ngIf="$any(input)?.file?.version > 1" [file]="$any(input).file" class="version-badge"></file-version-badge>
                </span>
              </ng-container>
              <div *ngIf="job.inputList.length > 1">
                <a *ngIf="job.inputLimit <= 1" (click)="job.inputLimit = 5000" class="text-muted">
                  <small>{{ 'jobProvenance.labels.showMoreFiles' | translate | interpolate:(job.inputList.length - 1) }}</small>
                </a>
                <a *ngIf="job.inputLimit > 1" (click)="job.inputLimit = 1" class="text-muted">
                  <small>{{ 'common.actions.hide' | translate }}</small>
                </a>
              </div>
            </td>
            <td test-id="prov-output-files">
              <i *ngIf="job.state === 'failed' && job.retried" class="text-muted">
                {{ 'jobProvenance.labels.jobRetried' | translate }}
              </i>
              <ng-container *ngFor="let output of job.outputList | slice:0:job.outputLimit">
                <span class="file-name">
                  <fw-ellipsis [text]="output.name" [tooltip]="output.tooltip"></fw-ellipsis>
                  <file-version-badge *ngIf="output?.version > 1" [file]="output" class="version-badge"></file-version-badge>
                </span>
              </ng-container>
              <div *ngIf="job.outputList.length > 1">
                <a *ngIf="job.outputLimit <= 1" (click)="job.outputLimit = 5000">
                  <small>{{ 'jobProvenance.labels.showMoreFiles' | translate | interpolate:(job.outputList.length - 1) }}</small>
                </a>
                <a *ngIf="job.outputLimit > 1" (click)="job.outputLimit = 1">
                  <small>{{ 'common.actions.hide' | translate }}</small>
                </a>
              </div>
            </td>
            <td class="actions">
              <button mat-flat-button color="primary" test-id="prov-retry-button" (click)="retryJob(job)"
                *ngIf="isAdmin && job.state === 'failed' && !job.retried">
                {{ 'common.actions.retry' | translate }}
              </button>
              <button mat-flat-button color="primary" test-id="prov-cancel-button" (click)="cancelJob(job)"
                *ngIf="isAdmin && (job.state === 'pending' || job.state === 'running')">
                {{ 'common.actions.cancel' | translate }}
              </button>
              <button mat-stroked-button (click)="displayJobLog(job)">
                {{ 'jobProvenance.labels.viewLog' | translate }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <button mat-stroked-button class="load-more" *ngIf="jobs.length < totalJobs" (click)="nextPage()">
        {{ 'common.actions.loadMore' | translate }}
        <small>{{ 'common.labels.displayRange' | translate | interpolate:0:jobs.length:totalJobs }}</small>
      </button>
    </div>
  </ng-container>
</ng-container>

<!-- Loading State -->
<ng-template #loadingState>
  <div class="blank-state">
    <img src="/assets/images/loading.svg" style="margin-bottom:10px">
    <p>Loading jobs...</p>
  </div>
</ng-template>

<!-- Blank State -->
<ng-template #emptyState>
  <div class="blank-state">
    <fw-icon size="large" color="slate" class="circle-shadow">settings-gear</fw-icon>
    <p>No jobs have run!</p>
    <button type="button" (click)="refreshJobs()" class="btn btn-primary">Refresh</button>
  </div>
</ng-template>
